import { useSearchParams } from 'react-router';
import { ErrorNotice, LoadingNotice } from '../../components/ErrorNotice';
import { useCurrentUser } from '../auth/auth.api';
import { useMemberships } from '../workspace/workspace.api';
import { DeviceSessionsSection } from './DeviceSessionsSection';
import { MfaSection } from './MfaSection';
import { PasswordSection } from './PasswordSection';
import { phrase } from '../../lib/i18n/runtime';

export function SecurityPage() {
  const [searchParams] = useSearchParams();
  const me = useCurrentUser();
  const memberships = useMemberships();
  const requiringWorkspaces = (memberships.data?.items ?? []).filter(
    (item) => item.mfaEnrollmentRequired,
  );
  const mfaRequired = searchParams.get('mfa') === 'required' || requiringWorkspaces.length > 0;

  if (me.isPending) {
    return <LoadingNotice>{phrase('Loading security settings…')}</LoadingNotice>;
  }
  if (me.isError) {
    return <ErrorNotice error={me.error} />;
  }

  return (
    <div className="stack stack--lg">
      <h1>{phrase('Security')}</h1>
      {mfaRequired && !me.data.mfaEnabled && (
        <p className="notice notice--warn" role="alert">
          <span aria-hidden="true">! </span>
          {requiringWorkspaces.length > 0
            ? `${requiringWorkspaces.map((item) => item.workspace.name).join(', ')} requires`
            : phrase('Your workspace requires')}{' '}
          two-step verification for your role. Set up an authenticator app below to continue working
          in the workspace.
        </p>
      )}
      <PasswordSection user={me.data} />
      <MfaSection />
      <DeviceSessionsSection />
    </div>
  );
}
